document.addEventListener("DOMContentLoaded", () => {
  // Updated to work with payment method toggle (not variants)
  const wireBtn = document.querySelector(".product-single__meta .payment-variant-input-wrap > .variant__button-label.first-variant-option");
  const creditBtn = document.querySelector(".product-single__meta .payment-variant-input-wrap > .variant__button-label:not(.first-variant-option)");
  const wireTransferModalBtn = document.querySelector(".page-content--product .product-single__meta .wti-modal-btn");
  const makeOfferBtn = document.querySelector(".page-content--product .product-single__meta .mao-modal-btn");
  const paymentButtons = document.querySelector(".payment-buttons");

  console.log('Payment method buttons:', { wireBtn, creditBtn, wireTransferModalBtn, makeOfferBtn });

  // Exit if required elements don't exist
  if (!wireBtn || !creditBtn || !wireTransferModalBtn || !makeOfferBtn) {
    console.log('Some payment method elements not found, exiting');
    return;
  }

  /**
   * Apply display state based on selected payment method
   * @param {string} paymentType - 'wire' or 'credit'
   */
  const applyState = (paymentType) => {
    const isWire = paymentType === "wire";

    // Wire Transfer: Show wire button, HIDE all payment buttons
    // Credit Card: HIDE wire button, SHOW all payment buttons
    
    // Toggle wire transfer button visibility
    if (wireTransferModalBtn) {
      wireTransferModalBtn.style.display = isWire ? '' : 'none';
      wireTransferModalBtn.classList.toggle("is-hidden", !isWire);
    }
    
    // Find and toggle ALL payment-related buttons
    // 1. Payment buttons wrapper (contains Add to Cart + dynamic payment buttons)
    if (paymentButtons) {
      paymentButtons.style.display = isWire ? 'none' : 'flex';
      console.log('Payment buttons wrapper display set to:', paymentButtons.style.display);
    }
    
    // 2. Individual Add to Cart button (fallback if not in wrapper)
    const addToCartButtons = document.querySelectorAll('[id^="AddToCart-"], .add-to-cart');
    addToCartButtons.forEach(btn => {
      if (!btn.classList.contains('wti-modal-btn') && !btn.classList.contains('mao-modal-btn')) {
        const newDisplay = isWire ? 'none' : '';
        btn.style.display = newDisplay;
        
        // FORCE ENABLE the button - override theme.js which disables it
        if (!isWire) {
          // Use setTimeout to override theme.js after it runs
          setTimeout(() => {
            btn.removeAttribute('disabled');
            btn.classList.remove('disabled');
            const btnText = btn.querySelector('span');
            if (btnText && (btnText.textContent.includes('Unavailable') || btnText.textContent.includes('sold out'))) {
              btnText.textContent = 'Add to cart';
            }
          }, 100);
        }
        
        console.log('Add to Cart button display set to:', newDisplay, 'disabled:', btn.disabled, 'button:', btn);
      }
    });
    
    // 3. Shopify dynamic payment buttons (Buy Now, etc)
    const dynamicPaymentButtons = document.querySelectorAll('.shopify-payment-button, [data-shopify-buttoncontainer]');
    dynamicPaymentButtons.forEach(btn => {
      const newDisplay = isWire ? 'none' : '';
      btn.style.display = newDisplay;
      console.log('Dynamic payment button display set to:', newDisplay, 'button:', btn);
    });

    // Toggle active states on payment method buttons
    wireBtn.classList.toggle("active", isWire);
    creditBtn.classList.toggle("active", !isWire);

    // Add margin to make an offer button when wire transfer button is hidden
    makeOfferBtn.classList.toggle("add-margin", !isWire);

    // Save state to localStorage
    localStorage.setItem("selectedPaymentMethod", paymentType);
    
    console.log('Applied state:', { 
      paymentType, 
      isWire, 
      paymentButtonsFound: !!paymentButtons,
      addToCartCount: addToCartButtons.length,
      dynamicButtonsCount: dynamicPaymentButtons.length
    });
  };

  // Set initial state based on which radio button is checked (wire is default)
  const checkedRadio = document.querySelector('input[name="payment_method"]:checked');
  const initialPaymentType = checkedRadio ? checkedRadio.getAttribute('data-payment-type') : 'wire';
  applyState(initialPaymentType);

  // Event listeners for payment method buttons - let the radio button click handle state changes
  wireBtn.addEventListener("click", () => {
    const wireRadio = document.querySelector('input[data-payment-type="wire"]');
    if (wireRadio && !wireRadio.checked) wireRadio.click();
  });

  creditBtn.addEventListener("click", () => {
    const creditRadio = document.querySelector('input[data-payment-type="credit"]');
    if (creditRadio && !creditRadio.checked) creditRadio.click();
  });

  // Listen for payment method changes from variant-button-new.liquid
  document.addEventListener('paymentMethodChanged', (event) => {
    console.log('paymentMethodChanged event received:', event.detail);
    const { paymentType } = event.detail;
    applyState(paymentType);
  });
});
